import React from "react";

const ClinicalSwabsDesktop = React.lazy(() => import("./ui/ClinicalSwabs"));

export const ClinicalSwabsPage = () => {
  return <ClinicalSwabsDesktop />;
};
